import { CardContent, Typography,Card,Stack,Box } from "@mui/material";
import CustomIcon from "../../../../components/customIcon";
import { useEffect, useRef } from "react";

export const InvestCardComponent = (props) => {
    const ref = useRef();
    useEffect(() => {
        if (ref && ref.current) {
            ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    }, [])
    return (
        <Card ref={ref} sx={{ borderRadius: "10px" }}>
            <CardContent sx={{ padding: { md: 3, xs: 2 } }} >
                <Stack direction={"row"} alignItems={"center"} spacing={1.5}>
                    <Typography variant="body3" sx={{ fontWeight: 500 }}>{props.title}</Typography>
                    {
                        props.info &&
                        <CustomIcon name="info" sx={{ width: 12, height: 12 }} />
                    }
                </Stack>
                <Box mt={2}>
                    {
                        props.children
                    }
                </Box>
            </CardContent>
        </Card>
    )
}